<template>
  <div>
      <!-- 打印display: none; -->
      <div style="position: absolute;bottom: 100px;left: 500px;width: 700px;display: none;">
        <div id='printBill'>
          <div style="font-size: 14px;color: #000000;font-family: 楷体;">
            <!-- <div style="width: 100%;text-align: center;margin-top: 30px;font-size: 20px;">中奥物业 收款收据</div> -->
            <div style="width: 100%;text-align: center;margin-top: 30px;font-size: 20px;">{{goods.company}} 收款收据</div>
            <div style="margin-top: 7px;display: flex;width: 100%;">
              <div style="width: 75%;">房号：{{goods.h_name_date}}</div>
              <div style="width: 25%;margin-left: 50px;">付款方式：{{goods.pays}}</div>
            </div>
            <div style="margin-top: 7px;display: flex;width: 100%;">
              <div style="width: 40%;">业主：{{goods.h_name}}</div>
              <div style="width: 33%;margin-left: 5px;">收据单号：{{goods.bill_number}}</div>
              <div style="width: 34%;text-align: right;margin-right: 25px;">开票日期：{{goods.date1}}</div>
            </div>
            <div style="margin-top:1px;line-height: 17px;">
              <!-- 中奥 -->
              <div v-if="goods.house_type != 4">
                <table align="center" style="width: 100%;border-collapse: collapse;">
                    <tr>
                        <th style="border:1px solid #000000;width: 150px;" align="center" valign="middle">收费项目</th>
                        <th style="border:1px solid #000000;width: 200px;" align="center" valign="middle">计费周期</th>
                        <th style="border:1px solid #000000;width: 90px;" class="ddd" align="center" valign="middle">面积</th>
                        <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">数量</th>
                        <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">单价</th>
                        <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">违约金</th>
                        <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">金额</th>
                    </tr>
                    <tr v-for="it in orders">
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.chargeitem_name}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.startDate}}-{{it.endDate}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charging}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.xsc_Amount}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charges}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.delaySum}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charge}}</td>
                    </tr>
                    <tr>
                        <td style="border:1px solid #000000;" align="center" valign="middle">合计（大写）：</td>
                        <td style="border:1px solid #000000;text-align: left;" colspan="4" align="center" valign="middle">
                          <span style="margin-left: 5px;">{{capitalize}}</span>
                        </td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">（小写）：</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{goods.charge}}</td>
                    </tr>
                    <tr>
                        <td style="border:1px solid #000000;" align="center" valign="middle">备注：</td>
                        <td style="border:1px solid #000000;text-align: left;" colspan="6" align="center" valign="middle">
                          <span style="margin-left: 5px;">{{goods.beizhus}}</span>
                        </td>
                    </tr>
                </table>
              </div>
              <!-- 永成 -->
              <div v-else>
                <table align="center" style="width: 100%;border-collapse: collapse;">
                    <tr>
                        <th style="border:1px solid #000000;width: 150px;" align="center" valign="middle">收费项目</th>
                        <th style="border:1px solid #000000;width: 200px;" align="center" valign="middle">计费周期</th>
                        <th style="border:1px solid #000000;width: 90px;"  align="center" valign="middle">面积</th>
                        <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">数量</th>
                        <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">单价</th>
                        <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">金额</th>
                    </tr>
                    <tr v-for="it in orders">
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.chargeitem_name}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.startDate}}-{{it.endDate}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charging}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.xsc_Amount}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charges}}</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charge}}</td>
                    </tr>
                    <tr>
                        <td style="border:1px solid #000000;" align="center" valign="middle">合计（大写）：</td>
                        <td style="border:1px solid #000000;text-align: left;" colspan="3" align="center" valign="middle">
                          <span style="margin-left: 5px;">{{capitalize}}</span>
                        </td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">（小写）：</td>
                        <td style="border:1px solid #000000;" align="center" valign="middle">{{goods.charge}}</td>
                    </tr>
                    <tr>
                        <td style="border:1px solid #000000;" align="center" valign="middle">备注：</td>
                        <td style="border:1px solid #000000;text-align: left;" colspan="5" align="center" valign="middle">
                          <span style="margin-left: 5px;">{{goods.beizhus}}</span>
                        </td>
                    </tr>
                </table>
              </div>

            </div>
            <div style="width: 70%;margin-top: 20px;">说明：第一联为存根（白色），第二联为客户（红色），第三联为记账（黄色）</div>
            <div style="margin-top: 7px;display: flex;width: 100%;">
              <div style="width: 33%;">开票人：{{login}}</div>
              <div style="width: 33%;">收款人：{{login}}</div>
              <div style="width: 34%;text-align: right;margin-right: 150px;">收款单位（盖章）</div>
              <div v-if="goods.img != '' && goods.img != null" style="position: fixed;right: 50px;opacity:0.7;margin-top: -40px;"><img :src="url+goods.img"/></div>
              <!-- <div style="position: fixed;right: 50px;opacity:0.7;margin-top: -30px;"><img src="http://www.zhoaoss.com/storage/yc/bill/1.png"/></div> -->
            </div>
            <div style="margin-top: 7px;display: flex;width: 100%;">
              <div style="width: 33%;"></div>
              <div style="width: 33%;"></div>
              <div style="width: 34%;text-align: right;margin-right: 70px;">
                打印时间：{{goods.date2}}
              </div>
            </div>
            <div style="text-align: center;margin-top: 7px;">打印次数<span style="margin-left: 30px;">{{goods.frequency}}</span></div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import print from 'print-js';
  export default {
      // 接受父组件的值
      props: {

      },
      watch:{

      },
      data () {
        return {
          login:'',
          goods:{
            h_name_date:'',
            pays:'',
            h_name:'',
            bill_number:'',
            date1:'',
            charge:'',
            beizhus:'',
            frequency:''
          },
          orders:[],
          capitalize:'',
          url:''
        }
      },
      mounted(){
      },
      //事件
      methods: {
        //返回数据
        getPrints(id,money,pid){
          this.url = this.$myhttp.defaults.baseURL+"/storage/yc/bill/";
          this.$confirm('是否打印票据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal:false
          }).then(() => {
           this.billPrintClick(id,money,pid)
          }).catch(() => {

          });
        },
        //打印查询数据
         billPrintClick(ids,money,pid){
          //应收费用账单查询
          let item = {id:ids,'money':money,'pid':pid}
          this.login = window.localStorage.getItem('login');
          this.$myhttp.post('admin/OrderList/getPrint',item,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
                this.goods = backdata.data.goods;
                this.orders = backdata.data.order;
                this.capitalize = this.transCnMoney(this.goods.charge);
                this.day();
          });
        },
        //数字转大写
        transCnMoney(number){
           var CN_MONEY = "";
           var CN_UNIT = "仟佰拾亿仟佰拾万仟佰拾元角分";
              number =  parseFloat(number).toFixed(2).toString();//浏览器默认为整数型,将数字转为2位有效数字的float类型再转为字符串
           var dot = number.indexOf('.');//将从小数点开始分开
           if(dot >=0){
              number = number.substring(0,dot)+number.substr(dot+1,2);
              CN_UNIT=CN_UNIT.substr(CN_UNIT.length-number.length);
              for (var i = 0; i < number.length; i++){
               CN_MONEY += '零壹贰叁肆伍陆柒捌玖'.substr(number.substr(i, 1), 1) + CN_UNIT.substr(i, 1);
              }
              return CN_MONEY.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元");
            }else{

            }
        },
        //打印
        day(){
          let _this = this;
          setTimeout(function(){
            const style = '@page {margin:0 10mm};'//打印时去掉眉页眉尾
            printJS({
              printable: 'printBill',// 标签元素id
              type: 'html',
              header: '',
              targetStyles: ['*'],
              scanStyles:false,//打印必须加上，不然页面上的css样式无效
              style,
              //打开打印界面
              onLoadingStart: () => {
                //console.log('loading-start')
              },
              //界面打开成功结束
              onLoadingEnd: () => {
                //console.log('loading-end')
              },
              //关闭回调
              onPrintDialogClose: () => {
                //console.log("关闭回调")
              },
              onError: e => {
                //console.log('打印失败')
              },
            });
          },100)
        }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/prints.vue